'use client'

import React from 'react'
import Link from 'next/link'
import { Button } from '@mantine/core'
import { StoreAnalytics, trackStoreEvent } from '@nile/mantine-theme/analytics'

interface NavLinkButtonProps {
    label: string
    href: string
}

export function NavLinkButton({ label, href }: NavLinkButtonProps) {
    return (
        <Button
            variant="subtle"
            component={Link}
            href={href}
            onClick={() => trackStoreEvent(StoreAnalytics.NAV_HEADER_CLICKED, { name: `${label}-button` })}
            data-testid={`${label}-button`}
            px={16}
            py={8}
            h="auto"
            fz={14}
            fw={500}
            lh="140%"
            c="var(--gm-fg-primary-black, #1f1e1d)"
            __vars={{
                '--button-hover': 'var(--gm-bg-highlight-cont, rgba(45, 26, 255, 0.1))',
                '--button-hover-color': 'var(--gm-blue, #2d1aff)',
            }}
        >
            {label}
        </Button>
    )
}
